import { render } from "./HeaderButton.vue?vue&type=template&id=2ff618ae&scoped=true"
import script from "./HeaderButton.vue?vue&type=script&lang=js"
export * from "./HeaderButton.vue?vue&type=script&lang=js"

import "./HeaderButton.vue?vue&type=style&index=0&id=2ff618ae&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ff618ae"]])

export default __exports__